export default function Image({ src, skip_link = false }) {
  return skip_link ? (
    <img src={src} alt="" />
  ) : (
    <a href={src} target="_blank" rel="noopener noreferrer">
      <img src={src} alt="" />
    </a>
  );
}
